import React, { useState, useEffect } from "react";
import { Grid, TextField, Button } from "@material-ui/core";
import { Search as SearchIcon } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import removalsActions from "../../../redux/actions/removals";

export default function Search() {
  const [searchText, setSearchText] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const dispatch = useDispatch();
  const removals = useSelector((state) => state.removals);
  const app = useSelector((state) => state.app);

  useEffect(() => {
    const now = new Date();
    const end = now.toISOString().split("T")[0]; // hoy
    const threeMonthsAgo = new Date(now.setMonth(now.getMonth() - 3));
    const start = threeMonthsAgo.toISOString().split("T")[0]; // hace 3 meses

    try {
      const parsed = JSON.parse(removals.search || '{}');
      setSearchText(parsed.search || "");
      setStartDate(parsed.startDate || start);
      setEndDate(parsed.endDate || end);
    } catch (err) {
      console.warn("Search no era un JSON válido");
      setSearchText("");
      setStartDate(start);
      setEndDate(end);
    }
  }, [removals.search]);

  const handleSubmit = () => {
    if (new Date(startDate) > new Date(endDate)) {
      alert("La fecha de inicio no puede ser mayor que la de término");
      return;
    }

    const searchPayload = JSON.stringify({
      search: searchText,
      startDate,
      endDate,
    });

    dispatch(removalsActions.setSearch({ search: searchPayload }));
  };

  return (
    <Grid 
    container 
    alignItems="center" 
    spacing={2} 
    style={{ marginBottom: 10 }}
    >
      <Grid item>
        <TextField
          variant="outlined"
          margin="dense"
          placeholder="nombre, apellido, email, teléfono"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
      </Grid>
      <Grid item>
        <TextField
          variant="outlined"
          margin="dense"
          label="Fecha inicio"
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          InputLabelProps={{ shrink: true }} // necesario para que el label no se superponga con el date picker
        />
      </Grid>

      <Grid item>
        <TextField
          variant="outlined"
          margin="dense"
          label="Fecha final"
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>

      <Grid item>
        <Button
          variant="contained"
          color="primary"
          style={{ height: 40, marginTop: 3 }}
          onClick={handleSubmit}
          startIcon={<SearchIcon />}
          disabled={app.loading}
        >
          Buscar
        </Button>
      </Grid>
    </Grid>
  );
}
